import { Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

const VideoModal = ({ el, showVideo, handleVideoCancel }) => {
  const [embedUrl, setEmbedUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   
    if (showVideo && el?.videos?.length > 0) {
      setLoading(true);
      const url = extractVideoEmbedURL(el.videos);
      setEmbedUrl(url);
      setLoading(false);
    }

    // Clear on close
    if (!showVideo) {
      setEmbedUrl(null);
    }
  }, [showVideo, el]);

  function extractVideoEmbedURL(urls) {
    if (!urls || !urls[0]) return null;
    const url = urls[0];

    try {
      const parsedUrl = new URL(url);

      if (parsedUrl.hostname.includes("youtube.com")) {
        const id = parsedUrl.searchParams.get("v");
        return `https://www.youtube.com/embed/${id}`;
      }

      if (parsedUrl.hostname === "youtu.be") {
        const id = parsedUrl.pathname.split("/").pop();
        return `https://www.youtube.com/embed/${id}`;
      }

      if (parsedUrl.hostname.includes("loom.com")) {
        const id = parsedUrl.pathname.split("/").pop();
        return `https://www.loom.com/embed/${id}`;
      }

      return null;
    } catch (error) {
      console.error("Invalid URL:", url);
      return null;
    }
  }

  return (
    <Modal
     visible={showVideo}
      footer={false}
      onCancel={handleVideoCancel}
      width="80%"
      style={{ height: "auto", marginTop: "-90px" }}
      destroyOnClose
    >
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        {loading ? (
          <Spin/>
        ) : embedUrl ? (
          <iframe
            width="100%"
            height="500px"
            src={embedUrl}
            title={el?.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        ) : (
          <div>No valid video found</div>
        )}
      </div>
    </Modal>
  );
};

export default VideoModal;
